<template>
  <div 
    class="totem-header-main"
    :style="{ 
      height: !onlyBar && !onlyParrilla ? '680px' : onlyBar ? '73px' : '607px',
      top: !onlyBar && !onlyParrilla ? '0' : onlyBar ? '0' : '607px',
    }"
  >
    <div
      v-if="!onlyParrilla"
      class="totem-header-bar"
    >
      <v-layout wrap 
        style="height: 100%;background-color: white;"
        :style="{ fontFamily: font,'background-color': bgColor, color: textColor }"
      >
        <v-flex xs4
          style="text-align:center;backgound-size:cover;"
          @click="handleReload"
        >
        <!--v-flex xs4
          style="text-align:center;backgound-size:cover;"
          :style="{ 'background-image': `url('${logo}')` }"
          @click="handleReload"
        -->
          <v-img
            :src="logo"
            style="height:73px; width:360px;"
          />
        </v-flex>
        <v-flex xs6
          style="padding-top:20px;text-align:center;-webkit-box-shadow: 10px 0px 5px -2px #888;box-shadow: inset 10px 0px 10px #00000033;"
        >
          {{ date }}
        </v-flex>
        <v-flex xs2
          style="padding-top:20px;text-align:center;-webkit-box-shadow: 10px 0px 5px -2px #888;box-shadow: inset 10px 0px 10px #00000033;"
          :style="{ fontFamily: font,'background-color': bgSecondaryColor, color: textSecondaryColor }"
        >
          {{ time }}
        </v-flex>
      </v-layout>
    </div>

    <div
      v-if="!onlyBar"
      class="totem-header-parrilla"
    >
    <!--background
      :parrilla="enterprise.Parrilla"
    /-->
    </div>
  </div>
</template>
<script>
import utils from '@/services/utils'
//import Background from './Background'
export default {
  components: {
 //   Background,
  },
  props: {
    enterprise: {
      type: Object,
      required: true,
    },
    locale: {
      type: String,
      default: 'es'
    },
    onlyBar: {
      type: Boolean,
      default: false,
    },
    onlyParrilla: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    date: '',
    time: '',
  }),
  computed: {
    bgColor () {
      return this.enterprise.BGColor
    },
    textColor () {
      return this.enterprise.Color
    },
    bgSecondaryColor () {
      return this.enterprise.BGColorSecundary
    },
    textSecondaryColor () {
      return this.enterprise.ColorSecundary
    },
    font () {
      return this.enterprise.Font
    },
    logo () {
      return this.enterprise.Logo ? this.enterprise.Logo : 'https://dtouch.es/assets/72c0948f-7eef-4d82-ab84-f94862c7a37f/e11a8bf0-5c3b-11e9-b777-8fe58a86ecf4.png'
    },
  },
  watch: {
    locale () {
      this.prepareHeader()
    },
  },
  created () {
    setInterval(this.prepareHeader, 60000)
  },
  mounted () {
    this.prepareHeader()
  },
  methods: {
    prepareHeader () {
      this.prepareDate()
      this.prepareTime()
    },
    prepareDate () {
      this.date = new Date().toLocaleDateString(this.locale, {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      })
    },
    prepareTime () {
      this.time = `${utils.pad(new Date().getHours())}:${utils.pad(new Date().getMinutes())}`
    },
    handleReload () {
      location.reload()
    },
  },
}
</script>
<style scoped>
.totem-header-main {
  position:fixed;
  top:0px;
  background-color: white;
  width: 1080px;
}
.totem-header-bar {
  height: 73px;
  width: 1080px;
  background-color: white;
  font-size: 1.5rem;
}
.totem-header-parrilla {
  height: 607px;
  width: 1080px;
  background-color: white;
}
</style>

